/**
 * Bridges the Auth0 SDK, which lives in React context, to the plain modules that refresh tokens on a
 * 401 (Apollo's error link and fetchHandler, through `Auth.refreshAccessToken`).
 *
 * `Auth0AuthContextProvider` registers the SDK's `getAccessTokenSilently` while it is mounted. Having
 * a getter registered is what switches token refresh from Diglet to Auth0, so it follows the same
 * per-page-session sign-in choice as `AuthContextProvider`.
 */
export type Auth0TokenGetter = (options: { cacheMode: 'off' }) => Promise<string | undefined>;

let auth0TokenGetter: Auth0TokenGetter | null = null;

export const setAuth0TokenGetter = (getter: Auth0TokenGetter | null) => {
  auth0TokenGetter = getter;
};

export const getAuth0TokenGetter = () => auth0TokenGetter;
